import "./assets/css/fontawesome/css/all.min.css";
import Vue from "vue";
import store from "./store";
import router from "./router";
import AppComponent from "./app-component.vue";
//import vuetify from "@/plugins/vuetify"; // path to vuetify export
import axios from "axios";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsXrange from "highcharts/modules/xrange";
import HighchartsVue from "highcharts-vue";

HighchartsMore(Highcharts);
HighchartsXrange(Highcharts);

Vue.config.productionTip = false;
axios.interceptors.response.use(
    response => {
        return response;
    },
    function(error) {
        if (typeof error.response === "undefined") {
            //window.location = '/error/connection-lost'
            //console.log("undefined");
        }
        if (error && error.response && error.response.status && error.response.status === 401) {
            window.location = "/login";
        }
        if (error && error.response && error.response.status && error.response.status === 403) {
            window.location = "/login";
        }
        return Promise.reject(error.response);
    }
);

let xsrf_token_meta = document.querySelector('meta[name="_token"]');
axios.defaults.headers.common = {
    "X-Requested-With": "XMLHttpRequest"
};

axios.defaults.withCredentials = true;
if (xsrf_token_meta) {
    axios.defaults.headers.common["X-CSRF-TOKEN"] = xsrf_token_meta.getAttribute("content");
    axios.defaults.headers.common["X-Xsrftoken"] = xsrf_token_meta.getAttribute("content");
}
Vue.prototype.rn = Vue.filter("rn", function(value, decimals) {
    if (!value) return "0.00";
    if (!decimals && decimals !== 0) decimals = 2;
    value = (Math.round(value * 100) / 100)
        .toFixed(decimals)
        .toString()
        .split(".");
    value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return value.join(".");
});

store.dispatch("fetchTranslations", "et_EE");
Vue.prototype.t = Vue.filter("t", key => {
    if (store.state.translations && store.state.translations[key]) {
        return store.state.translations[key];
    }
    return key;
});

Vue.use(HighchartsVue);

let vueapp = new Vue({
    store,
    router,
    template: "<AppComponent/>",
    vuetify,
    components: { AppComponent }
}).$mount("#app");
export default vueapp;
